import { skipToken } from '@reduxjs/toolkit/query/react';
import { getAskAllTrailsError, useAskAllTrailsQuery } from '@/utils/askAllTrailsApi';
import { useAppSelector } from '@/utils/redux';

/**
 * The submitted Ask AllTrails question and its response. The sidebar and the map both call this, and since the args are
 * the ones stored at submit time they get the same object, so RTK Query makes one request and hands both the same response.
 *
 * A retry is a new submission, never a `refetch()`, so `isFetching` only ever means the submitted question is in flight.
 */
const useAskResponse = () => {
  const args = useAppSelector(state => state.ask.args);
  // `currentData`, not `data`: `data` keeps the previous question's response while a new one loads.
  const { currentData, error, isFetching } = useAskAllTrailsQuery(args ?? skipToken);

  return { error: error ? getAskAllTrailsError(error) : undefined, isFetching, page: currentData, request: args?.request };
};

export default useAskResponse;
